import React, { useState, useEffect, useRef, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import AuthContext from "../../../context/auth-context";
import { FlashSaleService } from "../../../services/flash-sale-service";
import { ProductService } from "../../../services/product-service";
import Select from "react-select";
import moment from "moment";

export const Content = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [createHide, setCreateEdit] = useState(true);
  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);
  const [viewHide, setHideView] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "FLASH_SALES" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "FLASH_SALES" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }

      if (
        loca.access_module.module_name == "FLASH_SALES" &&
        loca.permission_add === true
      ) {
        setCreateEdit(false);
      }

      if (
        loca.access_module.module_name == "FLASH_SALES" &&
        loca.permission_view === true
      ) {
        setHideView(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";

  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formRef = useRef();

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const [flashSaleID, setFlashSaleID] = useState();
  const [productId, setProductId] = useState("");
  const [filterProductId, setFilterProductId] = useState("");
  const [statusValue, setStatusValue] = useState("");
  

  const history = useHistory();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setFlashSaleID(e);
  };

  const handleShow3 = (e) => {
    setState({ show3: true });
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const [flashSale, setFlashSale] = useState([]);

  const [products, setProducts] = useState([]);
  const [flashProducts, setFlashProducts] = useState([]);
  const [selectedProductOption, setSelectedProductOption] = useState(null);
  const [selectedFlashProductOption, setSelectedFlashProductOption] = useState(null);
  

  const flashSalesSearch = async () => {
    try {
      const result = await FlashSaleService.flashSaleDetailsSearch(filterProductId, statusValue, rowsPerPage, page);
      setFlashSale(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const getAllFlashSaleProducts = async () => {
    try {
      const result = await FlashSaleService.allFlashSaleProductsNames();
      setFlashProducts(result);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const getAllProducts = async () => {
    try {
      const result = await ProductService.allproductsNames();
      setProducts(result);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onSubmitForm = async (
    values,

    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
      //todo extra validations
      setSubmitLoading(false);

      try {
        await FlashSaleService.flashSaleCreate(values);

        setSubmitLoading(true);
        notify("Flash sale successfully added");
        formRef.current.resetForm();
        handleClose();
        flashSalesSearch();
      } catch (err) {
        setSubmitLoading(true);
        //show error toast
        if (err.response.data.message !== undefined) {
          notifyWarning(err.response.data.message);
        } else {
          notifyWarning("Something Wrong");
        }
      }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await FlashSaleService.flashSaleDelete(flashSaleID);

      setSubmitLoading(true);
      notify("Flash sale successfully deleted");
      handleClose();
      flashSalesSearch();
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }

      //show error toast
    }
  };

  useEffect(() => {
    flashSalesSearch();
  }, [filterProductId, statusValue, rowsPerPage, page]);

  useEffect(() => {
    getAllFlashSaleProducts();
    getAllProducts();
  },[])

  const clearFilters = () => {
    getAllFlashSaleProducts();
    setSelectedFlashProductOption(null);
    setFilterProductId("");
    setStatusValue("");
    setPage(0);
    setRowsPerPage(10);
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const handleProductChange = (selectedOption, index) => {
    setProductId(selectedOption ? selectedOption.value : "");
  };

  const handleMainProductFilterChange = (selectedOption, index) => {
    setSelectedFlashProductOption(selectedOption);
    setFilterProductId(selectedOption ? selectedOption.value : "");
  };

  let FlashSaleProductOptions = flashProducts.map((product) => ({
    value: product.id,
    label: product.name,
    keyword: product.name.toLowerCase(),
  }));

  const filterFlashProductOption = (option, rawInput) => {
    const search = rawInput.toLowerCase().trim();
    const keywords = search.split(/\s+/); // split by spaces
    const optionText = option.data.keyword;
    
    return keywords.every((keyword) => optionText.includes(keyword));
  };

  let ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
    keyword: product.name.toLowerCase(),
  }));

  const filterProductOption = (option, rawInput) => {
    const search = rawInput.toLowerCase().trim();
    const keywords = search.split(/\s+/); // split by spaces
    const optionText = option.data.keyword;
    
    return keywords.every((keyword) => optionText.includes(keyword));
  };

  const columns = [
    {
      field: "flashsale_order",
      headerName: "ID",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "productId",
      headerName: "Product",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{params.row.product.name}</div>;
      },
    },
    {
      field: "actual_price",
      headerName: "Actual Price",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
      renderCell: (params) => {
        return <div>{params.row.product.price}</div>;
      },
    },
    {
      field: "discount_price",
      headerName: "Discount Price",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
    },
    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    {
      field: "exp_date",
      headerName: "Expire Date",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
      renderCell: (params) => {
        if (params.row.status === "ACTIVE") {
          return (
            <div>
              <span className="badge badge-success">ACTIVE</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-primary">EXPIRED</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerAlign: "left",  // Aligns the header text
      align: "center",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              window.open(`${window.location.origin}/flash-sale-edit/${params.row.id}`, '_blank');
            }}
            style={{ cursor: "pointer" }}
            hidden={editHide}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div hidden={deleteHide}>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id)
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-10">
                  <h6>Flash Sales</h6>
                </div>
                <div>
                  <Modal
                    show={state.show4}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        Confirm Deletion
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "2vh",
                      }}
                    >
                      <h6 style={{ color: "red" }}>
                        Are you sure you want to remove this item ?
                      </h6>
                    </div>
                    <Modal.Footer>
                      <div className="col-md-2" hidden={submitloading}>
                        <div className="spinner spinner-7">
                          <div className="bounce1" />
                          <div className="bounce2" />
                          <div className="bounce3" />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        // onClick={submitForm}
                        style={{ backgroundColor: "red" }}
                        onClick={onDelete}
                      >
                        Delete
                      </button>

                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="validationCustom15"></label>

                  <Select
                    options={FlashSaleProductOptions}
                    onChange={handleMainProductFilterChange}
                    isClearable
                    placeholder="Filter by Product"
                    filterOption={filterFlashProductOption}
                    value={selectedFlashProductOption}
                  />
                </div>
                <div className="col-md-3 mt-0">
                  <label htmlFor="validationCustom15">Status</label>
                      <div className="input-group">
                        <select
                          name="status"
                          className="form-control"
                          value={statusValue}
                          id="selectstatus"
                          required
                          onChange={(event) => {
                            setStatusValue(event.target.value);
                          }}
                        >
                          <option value="">ALL</option>
                          <option value="ACTIVE">ACTIVE</option>
                          <option value="EXPIRED">EXPIRED</option>
                        </select>
                      </div>
                </div>
                <div className="col-md-1">
                    <label htmlFor="validationCustom15"></label>
                    <div className="input-group">
                      <button
                          type="button"
                          className="btn btn-secondary shadow-none"
                          onClick={clearFilters}
                        >
                          Clear
                      </button>
                    </div>
                  </div>
                <div className="col-md-2 mt-4 ml-5">
                  {" "}
                  <div className="col-md-2 col-sm-4">
                    <button
                      type="button"
                      className="btn btn-primary shadow-none"
                      onClick={handleShow3}
                      hidden={createHide}
                    >
                      Add New
                    </button>
                  </div>
                  <Modal
                    show={state.show3}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        <i className="flaticon-share bg-primary text-white" />{" "}
                        New Flash Sale
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <Formik
                      initialValues={{
                        productId: "",
                        discount_price: "",
                        exp_date: "",
                      }}
                      validationSchema={Yup.object().shape({
                        productId: Yup.string().required("Required"),
                        discount_price: Yup.string().required("Required"),
                        exp_date: Yup.string().required("Required"),
                      })}
                      onSubmit={onSubmitForm}
                      innerRef={formRef}
                    >
                      {({
                        errors,
                        handleBlur,
                        handleChange,
                        touched,
                        values,
                        submitForm,
                        isValid,
                        setFieldValue,
                      }) => (
                        <div>
                          <Modal.Body>
                            <div>
                              <div className="mb-3">
                                <label htmlFor="validationCustom15">Product</label>
                                    <Select
                                      options={ProductOptions}
                                      onChange={(selectedOption)=>{
                                        setFieldValue('productId', selectedOption ? selectedOption.value : "")
                                        setProductId(selectedOption ? selectedOption.value : "")
                                      }}
                                      isClearable
                                      placeholder="Filter by Product"
                                      filterOption={filterProductOption}
                                      value={ProductOptions.find(option => option.value === productId)}
                                    />
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {touched.productId && errors.productId}
                                </div>
                              </div>
                              <div className="mb-3">
                                <label htmlFor="validationCustom08">
                                  Discount Price
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    name="discount_price"
                                    className="form-control"
                                    id="discountpriceId"
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.discount_price}
                                  />
                                </div>
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {touched.discount_price && errors.discount_price}
                                </div>
                              </div>

                              <div className="mb-3">
                                <label htmlFor="validationCustom08">
                                Expire Date
                                </label>
                                <div className="input-group">
                                  <input
                                    name="exp_date"
                                    type="date"
                                    className="form-control"
                                    id="expireDateid"
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.exp_date}
                                  />
                                </div>
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {touched.exp_date && errors.exp_date}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-2" hidden={submitloading}>
                              <div className="spinner spinner-7">
                                <div className="bounce1" />
                                <div className="bounce2" />
                                <div className="bounce3" />
                              </div>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <button
                              type="button"
                              className="btn btn-light"
                              onClick={handleClose}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary shadow-none"
                              onClick={submitForm}
                            >
                              Add
                            </button>
                          </Modal.Footer>
                        </div>
                      )}
                    </Formik>
                  </Modal>{" "}
                </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                  <DataGrid
                    rows={flashSale}
                    columns={columns}
                    disableExtendRowFullWidth={false}
                    pageSize={rowsPerPage}
                    pagination
                    hideFooter
                    autoHeight
                  />
                  <TablePagination
                    component="div"
                    count={count}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
